import React, {useEffect} from "react";
import "./css/ChangePeriodPopup.css"; // Separate CSS file for styling
import { usePopupStack } from "../../contexts/PopupStackContext";

const ChangePeriodPopup = ({
                               selectedPeriod,
                               tempFromDate,
                               tempToDate,
                               handlePeriodChange,
                               setTempFromDate,
                               setTempToDate,
                               handleOkClick,
                               onClose
                           }) => {
    const { push, pop } = usePopupStack();

    useEffect(() => {
        const popupEntry = { onClose }; // 🔥 Use the prop directly
        push(popupEntry);
        return () => pop();
    }, []);

    const handleClose = () => {
        pop(); // 🧹 Make sure to remove this popup from the stack manually
        onClose();
    };

    return (
        <div className="change-period-popup" onClick={(e) => e.stopPropagation()}>
            <h2>Change Period</h2>

            <div className="field">
                <label>Period:</label>
                <select value={selectedPeriod} onChange={handlePeriodChange}>
                    <option>Current Financial Year</option>
                    <option>Last Financial Year</option>
                    <option>Till Current Financial Year (all)</option>
                    <option>User Defined</option>
                </select>
            </div>

            <div className="field">
                <label>From:</label>
                {selectedPeriod === "User Defined" ? (
                    <input type="date" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} />
                ) : (
                    <span className="readonly-text">{tempFromDate}</span>
                )}
            </div>

            <div className="field">
                <label>To:</label>
                {selectedPeriod === "User Defined" ? (
                    <input type="date" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} />
                ) : (
                    <span className="readonly-text">{tempToDate}</span>
                )}
            </div>

            <div className="contract-buttons">
                <button type="button" onClick={handleOkClick}>Ok</button>
                <button type="button" onClick={handleClose}>Cancel</button>
            </div>
        </div>
    );
};

export default ChangePeriodPopup;
